import { useToasts } from '.';
import { Toast } from './components';
import './Toasts.scss';

const Toasts = () => {
  const [ toasts, { removeToast } ] = useToasts();

  return (
    <div className="Toasts">
      {toasts.map(toast =>
        <Toast
          {...toast}
          onDismiss={removeToast}
          key={toast.id}
        />  
      )}
    </div>
  )
}

export default Toasts;